"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketService = void 0;
var socket_io_client_1 = __importDefault(require("socket.io-client"));
var typedLocalStorage_1 = require("../../../utils/typedLocalStorage");
var SocketService = /** @class */ (function () {
    function SocketService(serverParams) {
        this.channel = 'widget';
        this.listeners = [];
        this.initUserData = null;
        this.joinResponseData = null;
        this.socketConnection = (0, socket_io_client_1.default)({ path: '/socket-chat/socket.io' });
        this.serverParams = serverParams;
        this.clientId = String(serverParams.initParamData.clientId);
        this.joinResponseSocketListener();
        this.newMessageSocketListener();
        this.deleteMessageSocketListener();
    }
    SocketService.prototype.registerChat = function (userData) {
        var data = __assign(__assign({ client_id: this.clientId, channel: this.channel }, this.serverParams.user), userData);
        typedLocalStorage_1.typedLocalStorage.setItem('userData', JSON.stringify(userData));
        this.initUserData = __assign({}, userData);
        this.joinResponseData = null;
        this.socketConnection.emit('join', data);
    };
    SocketService.prototype.joinResponseSocketListener = function () {
        var _this = this;
        this.socketConnection.on('join response', function (response) {
            if (response.status)
                _this.joinResponseData = response.data;
            _this.notifyListeners('join response', response.data);
        });
    };
    SocketService.prototype.newMessageSocketListener = function () {
        var _this = this;
        this.socketConnection.on('new message', function (messageDTO) {
            var _a, _b, _c, _d;
            /* send parent script signal to show notification */
            window.parent.postMessage({ type: 'new message' }, '*');
            /* Проверяем, если пришли новые данные админа, то обновляем joinResponseData */
            if (messageDTO.channel === 'admin' &&
                (((_b = (_a = _this.joinResponseData) === null || _a === void 0 ? void 0 : _a.executor) === null || _b === void 0 ? void 0 : _b.name) !== messageDTO.user.name ||
                    ((_d = (_c = _this.joinResponseData) === null || _c === void 0 ? void 0 : _c.executor) === null || _d === void 0 ? void 0 : _d.email) !== messageDTO.user.email)) {
                var data = __assign(__assign({ client_id: _this.clientId, channel: _this.channel }, _this.serverParams.user), _this.initUserData);
                _this.socketConnection.emit('join', data);
            }
            _this.notifyListeners('new message', messageDTO);
        });
    };
    SocketService.prototype.deleteMessageSocketListener = function () {
        var _this = this;
        this.socketConnection.on('message deleted', function (data) {
            window.parent.postMessage({ type: 'message deleted' }, '*');
            _this.notifyListeners('message deleted', data);
        });
    };
    SocketService.prototype.sendMessageEmit = function (_a) {
        var _b, _c, _d, _e, _f, _g, _h;
        var text = _a.text, replyToId = _a.replyToId, files = _a.files;
        var messageData = __assign({ text: text, parent_message_id: replyToId || null, files: files || null, channel: this.channel, is_admin: false, name: ((_b = this.joinResponseData) === null || _b === void 0 ? void 0 : _b.user.name) || ((_c = this.initUserData) === null || _c === void 0 ? void 0 : _c.name), email: ((_d = this.joinResponseData) === null || _d === void 0 ? void 0 : _d.user.email) || ((_e = this.initUserData) === null || _e === void 0 ? void 0 : _e.email), client_id: this.clientId || null, chat_key: ((_f = this.joinResponseData) === null || _f === void 0 ? void 0 : _f.chat_key) || null, user_id: ((_g = this.joinResponseData) === null || _g === void 0 ? void 0 : _g.user_id) || null, image_url: ((_h = this.joinResponseData) === null || _h === void 0 ? void 0 : _h.user.image_url) || undefined }, this.serverParams.user);
        this.socketConnection.emit('send message', messageData);
    };
    SocketService.prototype.deleteMessageEmit = function (messageId) {
        var _a, _b;
        this.socketConnection.emit('delete message', {
            id: String(messageId),
            client_id: this.clientId,
            channel: this.channel,
            user_id: (_a = this.joinResponseData) === null || _a === void 0 ? void 0 : _a.user_id,
            chat_key: (_b = this.joinResponseData) === null || _b === void 0 ? void 0 : _b.chat_key,
        });
    };
    /** Позволяет подписаться на события из React-компонента */
    SocketService.prototype.addEventListener = function (eventListener) {
        this.listeners.push(eventListener);
    };
    SocketService.prototype.removeEventListener = function (eventListener) {
        this.listeners = this.listeners.filter(function (listener) { return listener !== eventListener; });
    };
    /** Оповещает подписчиков об изменениях */
    SocketService.prototype.notifyListeners = function (eventName, data) {
        this.listeners.forEach(function (listener) { var _a; return (_a = listener[eventName]) === null || _a === void 0 ? void 0 : _a.call(listener, data); });
    };
    return SocketService;
}());
exports.SocketService = SocketService;
